import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { Button } from 'gu-ui-kit'

export const CustomButton = ({ children, startIcon, ...rest }) => {
  const breakpoints = useBreakpoint()
  return (
    <Button component={Link} {...rest} startIcon={startIcon}>
      {!breakpoints.xl ? null : children}
    </Button>
  )
}

CustomButton.propTypes = {
  children: PropTypes.node,
  startIcon: PropTypes.element,
  icon: PropTypes.string,
}
